module.exports = __webpack_public_path__ + "img/surfer2.7ac20b34.svg";